import { Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import React, { useEffect } from 'react';
import DefaultBanner from '../../assets/common.png';
import HouseIcon from '../../assets/bpims-house-icon.png';
import { useLocation, useNavigate } from 'react-router-dom';

const StyledContainer = styled(Container)`
    z-index: 0;
    background: linear-gradient(
            90deg,
            rgba(189, 210, 226, 1) 0%,
            rgba(189, 210, 226, 1) 35%,
            rgba(255, 255, 255, 0) 63%
        ),
        url(${DefaultBanner}) center center;
    background-size: cover;
    width: 100%;
    height: 100vh;
    clip-path: ellipse(70% 50% at 50% 65%);
    overflow: hidden;
    position: relative;
    margin-top: -50px;

    @media (min-width: 300px) and (max-width: 500px) {
        margin-top: -100px;
        background: linear-gradient(
            90deg,
            rgba(189, 210, 226, 1) 0%,
            rgba(189, 210, 226, 1) 35%,
            rgba(255, 255, 255, 0) 100%
        );
    }

    @media (max-height: 375px) and (max-height: 600px) and (min-width: 600px) and (max-width: 933px) {
        background: linear-gradient(
            90deg,
            rgba(189, 210, 226, 1) 0%,
            rgba(189, 210, 226, 1) 35%,
            rgba(255, 255, 255, 0) 100%
        );
        height: 110vh;
        margin-top: -70px;
    }
`;

const LogoRow = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: absolute;
    top: 50px; /* Adjust based on your needs */
    left: 0;
    padding: 0 20px; /* Adjust based on your needs */
    z-index: 1001;

    @media (min-width: 300px) and (max-width: 500px) {
        position: static;
        top: 0;
    }

    @media (max-height: 375px) and (max-height: 600px) and (min-width: 500px) and (max-width: 767px) {
        position: static;
    }
`;

const StyledImage1 = styled.img`
    margin: 6px;
    height: 50px;
    margin-top: 6px;

    @media (min-width: 300px) and (max-width: 500px) {
        margin: 0;
    }
`;

const StyledImage2 = styled.img`
    margin: 6px;
    height: 80px;

    @media (min-width: 300px) and (max-width: 500px) {
        margin: 0;
    }
`;

const Content = styled.div`
    position: absolute;
    top: 55%;
    left: 29%;
    transform: translate(-50%, -50%);
    text-align: justify;
    color: #003057; /* Adjust based on your needs */
    padding: 20px;
    z-index: 1000;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 100%;
        left: 58%;
        padding: 0;
    }

    @media (max-height: 375px) and (max-height: 600px) and (min-width: 500px) and (max-width: 767px) {
        left: 70%;
        width: 100%;
        padding-bottom: 20px;
    }
`;

const StyledButton = styled.a`
    background-color: #b01116;
    color: white;
    padding: 6px 20px;
    border: none;
    border-radius: 20px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    font-family: Montserrat, sans-serif;
`;

const StyledTitle = styled.h1`
    font-weight: 700;
    font-family: Montserrat, sans-serif;
`;

const StyledParagraph = styled.p`
    color: #b01116;
    font-size: 18px;
    line-height: 1.5;
    margin: 0;
    padding: 0; 
    font-family: Montserrat, sans-serif;
`;

const HouseIconImage = styled.img`
    height: 150px; /* Adjust based on your needs */
    margin-top: 40px;
`;

const scrollToElement = (id) => {
    setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, 300);
};


export default function HeaderComponent() {
    const location = useLocation();
    const navigate = useNavigate();

    const pathsToScroll = ['/faq', '/kyc', '/success', '/failed'];

    const handleNavigate = () => {
        navigate('/home'); 
        scrollToElement('claim');
    };

    // Automatically scroll to 'claim' section on page load for specific pages
    useEffect(() => {
        if (pathsToScroll.includes(location.pathname)) {
            scrollToElement('claim'); // Scroll to claim if on one of the specified pages
        }
    }, [location.pathname]);

    return (
        <>
            <LogoRow>
                <StyledImage1
                    style={{ height: '50px', marginTop: '6px' }}
                    src={require('../../assets/bpims-logo.png')}
                    alt="BPI Logo"
                />
                <StyledImage2
                    style={{ height: '80px' }}
                    src={require('../../assets/home-credit-logo-2.png')}
                    alt="Home Credit Logo"
                />
            </LogoRow>
            <StyledContainer fluid>
                <Content>
                    <Container>
                        <Row>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <StyledTitle>
                                    Pinag-ipunan. <br />
                                    Pinag-hirapan. <br />
                                    Patuloy na <br /> pag-ingatan.
                                </StyledTitle>
                                <HouseIconImage src={HouseIcon} alt="House Icon" />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <StyledParagraph>
                                Siguraduhing lahat ng gamit sa bahay ay <br/> protektado kontra sunog, baha at nakaw. <br/>Mag-renew ng Home Protection Insurance!
                                </StyledParagraph>
                            </Col>
                        </Row>
                        <Row className="pt-4">
                            <Col>
                                <StyledButton onClick={handleNavigate}>MAG-RENEW</StyledButton>
                            </Col>
                        </Row>
                    </Container>
                </Content>
            </StyledContainer>
        </>
    );
}
